import React, { useState } from "react"
import {
  Box,
  Button,
  FormControl,
  FormLabel as CFormLabel,
  FormErrorMessage,
  Input,
  Textarea,
  Heading,
  Checkbox,
  Text,
} from "@chakra-ui/react"
import PropTypes from "prop-types"
import { useForm } from "react-hook-form"
import Link from "./Link"
import { boatDripData } from "src/lib/helpers/drip-data"

const ContactForm = ({ boat, offer, search, setFormSubmitted, type }) => {
  const { register, handleSubmit } = useForm()
  const [submitting, setSubmitting] = useState(false)
  const [errorOccured, setErrorOccured] = useState(false)

  const onSubmit = async (data, e) => {
    try {
      setErrorOccured(false)
      setSubmitting(true)

      const names = data.full_name.split(" ")
      const [first_name, ...lastNames] = names
      const last_name = lastNames.join(" ")

      const dcq = window._dcq
      if (dcq) {
        dcq.push(["identify", { email: data.email, phone: data.phone, first_name, last_name }])
        dcq.push([
          "track",
          type === "reserve" ? "Send reserve" : "Send inquire",
          { message: data.message, marketing_consent: data.marketing_consent, ...boatDripData(boat, offer, search) },
        ])
      }
      setSubmitting(false)
      setFormSubmitted(true)
      e.target.reset()
    } catch (err) {
      setErrorOccured(true)
      setSubmitting(false)
      console.error(err)
    }
  }

  const formTitle = type === "reserve" ? "Your Reservation" : "Your inquiry"

  const ctaTitle = type === "reserve" ? "INQUIRE NOW" : "SEND INQUIRY"

  return (
    <div
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gridAutoRows: "min-content",
        gridRowGap: [4, 3],
      }}
    >
      <Heading as="h3" variant="h3" mt={[8, 0]} mb={8}>
        {formTitle}
      </Heading>
      <Box
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          input: { mb: 3 },
        }}
      >
        <FormControl isRequired>
          <CFormLabel htmlFor="full_name">Your name</CFormLabel>
          <Input {...register("full_name")} id="full_name" placeholder="Name and Surname" />
          <FormErrorMessage>This field is required</FormErrorMessage>
        </FormControl>
        <FormControl isRequired>
          <CFormLabel htmlFor="email">E-mail</CFormLabel>
          <Input {...register("email")} id="email" placeholder="your@email.com" />
          <FormErrorMessage>This field is required</FormErrorMessage>
        </FormControl>
        <FormControl>
          <CFormLabel htmlFor="phone">Phone (optional)</CFormLabel>
          <Input {...register("phone")} id="phone" placeholder="+44 7777 12345" />
          <FormErrorMessage>This field is required</FormErrorMessage>
        </FormControl>
        <FormControl>
          <CFormLabel htmlFor="message">Message (optional)</CFormLabel>
          <Textarea {...register("message")} id="message" placeholder="Your message..." />
          <FormErrorMessage>This field is required</FormErrorMessage>
        </FormControl>
        <Checkbox my={4} {...register("marketing_consent")}>
          Email me money-saving deals and expert sailing tips
          <Link to="/privacy-policy" sx={{ ml: 2, display: "inline-block" }}>
            Privacy Policy
          </Link>
        </Checkbox>
        <Button my={4} type="submit" w="100%" disabled={submitting}>
          {ctaTitle}
        </Button>
        {errorOccured && (
          <Text sx={{ color: "error" }}>
            {`An error occured while trying to send ${formTitle.toLowerCase()}. Please try again later.`}
          </Text>
        )}
        <Text>
          {`By clicking ${ctaTitle} above, you consent to allow HighSails to store and process the personal information submitted to provide you the content requested.`}
        </Text>
        {type === "reserve" && (
          <>
            <Text sx={{ gridColumn: "1 / 3" }}>
              You can reserve your boat for 72 hours for free. You won&apos;t be charged.
            </Text>
          </>
        )}
      </Box>
    </div>
  )
}

ContactForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  boat: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

export default ContactForm
